import { useContext } from 'react';

import { Switch, Route } from 'react-router-dom';

import CMSIndex from './CMSManagement/components/CMSIndex';
import CMSDetail from './CMSManagement/components/CMSDetail';
import { UserContext } from 'context/User/UserContext';

const CMSManagement = () => {
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);

	return (
		<Switch>
			<Route
				path='/CMSManagement/new'
				render={() => (
					<CMSDetail new={true} currentUser={contextUser.userInfo} />
				)}
			/>
			<Route
				path='/CMSManagement/:cmsObjectID'
				render={() => (
					<CMSDetail new={false} currentUser={contextUser.userInfo} />
				)}
			/>
			<Route path='/CMSManagement' render={() => <CMSIndex />} />
		</Switch>
	);
};

export default CMSManagement;
